/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Leo_Action_PhraseInputs */

const en_leo_action_phrase = /** @type {(inputs: Leo_Action_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`subscribe`)
};

const id_leo_action_phrase = /** @type {(inputs: Leo_Action_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`berlangganan`)
};

const ms_leo_action_phrase = /** @type {(inputs: Leo_Action_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`langgani`)
};

const ca_leo_action_phrase = /** @type {(inputs: Leo_Action_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`subscriu-te`)
};

const cs_leo_action_phrase = /** @type {(inputs: Leo_Action_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`odebírat`)
};

const da_leo_action_phrase = /** @type {(inputs: Leo_Action_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`tilmeld`)
};

const de_leo_action_phrase = /** @type {(inputs: Leo_Action_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abonnieren`)
};

const et_leo_action_phrase = /** @type {(inputs: Leo_Action_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`telli`)
};

const es_leo_action_phrase = /** @type {(inputs: Leo_Action_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`suscríbete`)
};

const fr_leo_action_phrase = /** @type {(inputs: Leo_Action_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`s’abonner`)
};

const hr_leo_action_phrase = /** @type {(inputs: Leo_Action_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`pretplatite se`)
};

const it_leo_action_phrase = /** @type {(inputs: Leo_Action_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abbonati`)
};

const lv_leo_action_phrase = /** @type {(inputs: Leo_Action_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`abonēt`)
};

const lt_leo_action_phrase = /** @type {(inputs: Leo_Action_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`prenumeruoti`)
};

const hu_leo_action_phrase = /** @type {(inputs: Leo_Action_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`feliratkozás`)
};

const nl_leo_action_phrase = /** @type {(inputs: Leo_Action_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`abonneren`)
};

const nb_leo_action_phrase = /** @type {(inputs: Leo_Action_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`bli abonnent`)
};

const pl_leo_action_phrase = /** @type {(inputs: Leo_Action_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`subskrybuj`)
};

const pt_leo_action_phrase = /** @type {(inputs: Leo_Action_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`assine`)
};

const ro_leo_action_phrase = /** @type {(inputs: Leo_Action_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`abonare`)
};

const sk_leo_action_phrase = /** @type {(inputs: Leo_Action_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`predplatiť`)
};

const sl_leo_action_phrase = /** @type {(inputs: Leo_Action_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`naročite se`)
};

const fi_leo_action_phrase = /** @type {(inputs: Leo_Action_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`tilaa`)
};

const sv_leo_action_phrase = /** @type {(inputs: Leo_Action_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`prenumerera`)
};

const vi_leo_action_phrase = /** @type {(inputs: Leo_Action_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`đăng ký`)
};

const tr_leo_action_phrase = /** @type {(inputs: Leo_Action_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`abone ol`)
};

const el_leo_action_phrase = /** @type {(inputs: Leo_Action_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`εγγραφή`)
};

const bg_leo_action_phrase = /** @type {(inputs: Leo_Action_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`абониране`)
};

const ru_leo_action_phrase = /** @type {(inputs: Leo_Action_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`подписаться`)
};

const sr_leo_action_phrase = /** @type {(inputs: Leo_Action_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`претплатите се`)
};

const uk_leo_action_phrase = /** @type {(inputs: Leo_Action_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`підписатися`)
};

const ka_leo_action_phrase = /** @type {(inputs: Leo_Action_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`გამოწერა`)
};

const hi_leo_action_phrase = /** @type {(inputs: Leo_Action_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सब्सक्राइब `)
};

const th_leo_action_phrase = /** @type {(inputs: Leo_Action_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`สมัครสมาชิก`)
};

const ko_leo_action_phrase = /** @type {(inputs: Leo_Action_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`구독`)
};

const zh_leo_action_phrase = /** @type {(inputs: Leo_Action_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`订阅`)
};

const zh_tw_leo_action_phrase = /** @type {(inputs: Leo_Action_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`訂閱`)
};

const ja_leo_action_phrase = /** @type {(inputs: Leo_Action_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`購入する`)
};

/**
* | output |
* | --- |
* | "subscribe" |
*
* @param {Leo_Action_PhraseInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const leo_action_phrase = /** @type {((inputs?: Leo_Action_PhraseInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Leo_Action_PhraseInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_leo_action_phrase(inputs)
	if (locale === "ms") return ms_leo_action_phrase(inputs)
	if (locale === "ca") return ca_leo_action_phrase(inputs)
	if (locale === "cs") return cs_leo_action_phrase(inputs)
	if (locale === "da") return da_leo_action_phrase(inputs)
	if (locale === "de") return de_leo_action_phrase(inputs)
	if (locale === "et") return et_leo_action_phrase(inputs)
	if (locale === "es") return es_leo_action_phrase(inputs)
	if (locale === "fr") return fr_leo_action_phrase(inputs)
	if (locale === "hr") return hr_leo_action_phrase(inputs)
	if (locale === "it") return it_leo_action_phrase(inputs)
	if (locale === "lv") return lv_leo_action_phrase(inputs)
	if (locale === "lt") return lt_leo_action_phrase(inputs)
	if (locale === "hu") return hu_leo_action_phrase(inputs)
	if (locale === "nl") return nl_leo_action_phrase(inputs)
	if (locale === "nb") return nb_leo_action_phrase(inputs)
	if (locale === "pl") return pl_leo_action_phrase(inputs)
	if (locale === "pt") return pt_leo_action_phrase(inputs)
	if (locale === "ro") return ro_leo_action_phrase(inputs)
	if (locale === "sk") return sk_leo_action_phrase(inputs)
	if (locale === "sl") return sl_leo_action_phrase(inputs)
	if (locale === "fi") return fi_leo_action_phrase(inputs)
	if (locale === "sv") return sv_leo_action_phrase(inputs)
	if (locale === "vi") return vi_leo_action_phrase(inputs)
	if (locale === "tr") return tr_leo_action_phrase(inputs)
	if (locale === "el") return el_leo_action_phrase(inputs)
	if (locale === "bg") return bg_leo_action_phrase(inputs)
	if (locale === "ru") return ru_leo_action_phrase(inputs)
	if (locale === "sr") return sr_leo_action_phrase(inputs)
	if (locale === "uk") return uk_leo_action_phrase(inputs)
	if (locale === "ka") return ka_leo_action_phrase(inputs)
	if (locale === "hi") return hi_leo_action_phrase(inputs)
	if (locale === "th") return th_leo_action_phrase(inputs)
	if (locale === "ko") return ko_leo_action_phrase(inputs)
	if (locale === "zh") return zh_leo_action_phrase(inputs)
	if (locale === "zh-tw") return zh_tw_leo_action_phrase(inputs)
	if (locale === "ja") return ja_leo_action_phrase(inputs)
	return en_leo_action_phrase(inputs)
});